<app-currencies-list [userType]="'public'" [listType]="'public'" [deleteType]="'admin'" [createType]="'admin'">
</app-currencies-list>